<template>
  <template v-if="loaded">
    <h4 v-if="items" :class="{ h2: !altTitleFont, t1: altTitleFont }" class="Collection-Slider-Title page-width" v-html="title" data-color="night-sky-dark"></h4>
    <div class="page-width" data-color="night-sky-dark">
      <p v-if="items && description !== ''" class="p7 Collection-Slider-Sub" v-html="description"></p>
      <div v-if="items && ctaLink" class="Collection-Slider-Cta-Wrapper--Med" data-color="night-sky-dark">
        <a class="button button--tertiary-a" :href="ctaLink">{{ ctaText }}</a>
      </div>
    </div>
    <Splide :has-track="false" @splide:moved="checkArrowState" @splide:mounted="setRole" @splide:updated="setRole" :options="Options" class="page-width" data-ht-module="product-cards">
      <SplideTrack>
        <SplideSlide v-for="item in items" :key="item.title">
          <ContentTile v-if="item.cardType === 'CONTENT'" />
          <ProductCard v-else :item="item" :ready="promoReady" :terms="terms" :selection-listener="selectionListener" />
        </SplideSlide>
      </SplideTrack>
      <div :class="{ hasDesc: description !== '' }" class="splide__arrows product-slider-arrows">
        <button class="splide__arrow splide__arrow--prev product-slider-arrow prev-arrow" type="button" aria-label="Previous slide">
          <Icon icon="splide-arrow" />
        </button>
        <button class="splide__arrow splide__arrow--next product-slider-arrow next-arrow" type="button" aria-label="Next slide">
          <Icon icon="splide-arrow" />
        </button>
      </div>
    </Splide>
    <div v-if="items && ctaLink" class="Collection-Slider-Cta-Wrapper" data-color="night-sky-dark">
      <a class="button button--tertiary-a Collection-Slider-Cta--Sml" :href="ctaLink">{{ ctaText }}</a>
    </div>
  </template>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import ContentTile from '../Global/ContentTile.vue';
import ProductCard from '../Global/ProductCard.vue';
import { Splide, SplideSlide, SplideTrack } from '@splidejs/vue-splide';
import { pubSub } from '@utils/PubSub';
import { FetchCards, Options } from './Composables/FetchCards.js';
import Icon from '../Global/Icon.vue';

const items = ref(null);
const title = ref(null);
const description = ref(null);
const altTitleFont = ref(false);
const ctaLink = ref(false);
const ctaText = ref(false);
const loaded = ref(false);
const promoReady = ref(false);
const terms = ref(null);

const props = defineProps({
  data: [Object, String],
  selectionListener: Boolean,
  nativeCollection: String,
  recommendation: { type: String, default: false },
  terms: Object,
});

const removeStencils = () => {
  const stencils = document.querySelectorAll('.js-collection-stencils');
  if (stencils.length <= 0) return;

  stencils.forEach((stencil) => stencil.remove());
};

const mountPromo = () => {
  pubSub.unsubscribe('dy:promo:init', mountPromo);
  pubSub.publish('dy:promo:ready');
};

const mountFallback = () => {
  pubSub.publish('dy:promo:ready');
};

const setPromo = () => {
  promoReady.value = true;
};

pubSub.subscribe('dy:promo:init', mountPromo, mountFallback);
pubSub.subscribe('dy:promo:ready', setPromo);

const setRole = (splide) => {
  splide.root.querySelector('.splide__list').setAttribute('role', 'group');
};

onMounted(async () => {
  if (!props?.data?.items) return;
  title.value = props.data.title;
  description.value = props.data.custom?.collectiondata.description;
  altTitleFont.value = props.data.custom?.collectiondata.altTitleFont === 'true';
  ctaLink.value = props.data.custom?.collectiondata.ctaLink != 'false' ? props.data.custom?.collectiondata.ctaLink : false;
  ctaText.value = props.data.custom?.collectiondata.ctaText != 'false' ? props.data.custom?.collectiondata.ctaText : false;
  const { items: data } = await FetchCards(props.data.items);
  items.value = data;
  terms.value = props.terms;
  if (data.length > 0) loaded.value = true;
  removeStencils();
});
</script>
